import React, { Component, useContext } from 'react';
import { Avatar, Spin, PageHeader, Tooltip, Layout, message, Row, Col, Card, Typography, Tabs, Menu, Space, Button, Result, Popconfirm, Tag, Empty, Badge } from 'antd'
import axios from 'axios';

import { FaRegHandshake } from 'react-icons/fa'
import { useParams, useNavigate, useLocation, matchRoutes } from "react-router-dom";


//Componentes
import Logged from '../../../../Hooks/Logged';
import CustomAvatar from '../../../Widgets/Avatar/Avatar';
import usePermissions from '../../../../Hooks/usePermissions';
import { IconArrowBack } from '../../../Widgets/Iconos';

//Modales






//modal


const { Content } = Layout;
const { Text, Title, Paragraph } = Typography;
const { TabPane } = Tabs;


const moment = require('moment');
moment.locale('es');

/**
 * @export
 * @class DetalleClientes
 * @extends {Component}
 * @description Vista de Detalle Clientes
 */
class InformacionGeneral extends Component {

    constructor(props) {
        super(props)
        this.state = {
            empleado: {},

        }
    }



    componentDidMount() {
        this.get()
    }



    /**
     * @memberof DetallesClientes
     * @method get
     * @description Obtiene los detalles y propiedades del cliente
     *
     */
    get = () => {
        this.setState({ loading: true })
        axios.get('/empleados/' + this.props.id)
            .then(({ data }) => {
                this.setState({ empleado: data })
            }).catch(error => {
                message.error('Error al obtener el empleado')
            }).finally(() => this.setState({ loading: false }))
    }


    render() {
        const { empleado, cliente } = this.state


        return (
            <>
                <Spin spinning={false}>


                    <Col span={24}>
                        <Card bordered>
                            <Row align="middle" className='mb-1' gutter={[12, 12]}>
                                <Col>
                                    <Title level={4} >Domicilio</Title>
                                </Col>
                            </Row>



                            <Col xs={24} lg={24}>
                                <Row>
                                    {
                                        empleado?.calle ?
                                            <Col xs={24} lg={12} xl={6}>
                                                <Paragraph>Calle / Avenida</Paragraph>
                                                <Paragraph strong style={{ fontSize: 16 }}>{empleado?.calle}</Paragraph>
                                            </Col> : null
                                    }

                                    {
                                        empleado?.numero_exterior ?
                                            <Col xs={24} lg={12} xl={6}>
                                                <Paragraph>Número</Paragraph>
                                                <Paragraph strong style={{ fontSize: 16 }}>{empleado?.numero_exterior}</Paragraph>
                                            </Col> : null
                                    }
                                    {
                                        empleado?.curp ?
                                            <Col xs={24} lg={12} xl={6}>
                                                <Paragraph>Interior</Paragraph>
                                                <Paragraph strong style={{ fontSize: 16 }}>{empleado?.numero_interior}</Paragraph>
                                            </Col> : null
                                    }
                                    {
                                        empleado?.rfc ?
                                            <Col xs={24} lg={12} xl={6}>
                                                <Paragraph>Colonia</Paragraph>
                                                <Paragraph strong style={{ fontSize: 16 }}>{empleado?.colonia}</Paragraph>
                                            </Col> : null
                                    }
                                    {
                                        empleado?.municipio ?
                                            <Col xs={24} lg={12} xl={6}>
                                                <Paragraph>Delegación o Municipio</Paragraph>
                                                <Paragraph strong style={{ fontSize: 16 }}>{empleado?.municipio}</Paragraph>
                                            </Col> : null
                                    }
                                    {
                                        empleado?.estado_residencia ?
                                            <Col xs={24} lg={12} xl={6}>
                                                <Paragraph>Estado de Residencia</Paragraph>
                                                <Paragraph strong style={{ fontSize: 16 }}>{empleado?.estado_residencia}</Paragraph>
                                            </Col> : null
                                    }
                                    {
                                        empleado?.pais_residencia ?
                                            <Col xs={24} lg={12} xl={6}>
                                                <Paragraph>País de Residencia</Paragraph>
                                                <Paragraph strong style={{ fontSize: 16 }}>{empleado?.pais_residencia}</Paragraph>
                                            </Col> : null
                                    }
                                    {
                                        empleado?.codigo_postal ?
                                            <Col xs={24} lg={12} xl={6}>
                                                <Paragraph>Código Postal</Paragraph>
                                                <Paragraph strong style={{ fontSize: 16 }}>{empleado?.codigo_postal}</Paragraph>
                                            </Col> : null
                                    }
                                
                                </Row>
                            </Col>



                        </Card>
                    </Col>

                </Spin>
            </>
        )
    }
}

export default function (props) {


    const user = useContext(Logged);

    const permisos = usePermissions(user?.rol_id?.permisos, {
        crearPropiedades: ["clientes", "propiedades", "create"],

        verTransaccionesPropiedad: ["clientes", "propiedades", "transacciones", "access"],
        crearTransaccionesPropiedad: ["clientes", "propiedades", "transacciones", "create"],

        verTransaccionesProgramadasPropiedad: ["clientes", "propiedades", "transacciones-programadas", "access"],
        crearTransaccionesProgramadasPropiedad: ["clientes", "propiedades", "transacciones-programadas", "create"],
    });

    return <InformacionGeneral

        {...permisos}
        {...props}
    />
}